var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("面板区")))]), _c("span", {
    attrs: {
      slot: "handle"
    },
    slot: "handle"
  }, [_vm._v(_vm._s(_vm.$t("蓝框为当前可编辑的区域可直接点击面板添加")))]), _vm.menu.indexOf("dashboardDataBoard") > -1 ? _c("div", {
    staticStyle: {
      "margin-top": "5px",
      color: "#999"
    },
    attrs: {
      slot: "des"
    },
    slot: "des"
  }, [_vm._v(" * " + _vm._s(_vm.$t("按照面板分类配置每个分类的页面，未配置的页面默认为无权限，前端不显示")) + " ")]) : _vm._e()]), _c("div", {
    staticClass: "btnBox"
  }, [_c("draggable", {
    attrs: {
      animation: "300",
      group: _vm.grpupA,
      sort: false,
      move: _vm.onMove
    },
    model: {
      value: _vm.panelList,
      callback: function ($$v) {
        _vm.panelList = $$v;
      },
      expression: "panelList"
    }
  }, [_c("transition-group", _vm._l(_vm.panelList, function (item, index) {
    return _c("div", {
      key: item.id,
      staticClass: "marginR15 marginB15 btnItem",
      attrs: {
        id: item.id,
        "data-num": index
      }
    }, [item.remarks ? _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t(item.remarks)) + " ")]), _vm._v(" " + _vm._s(item.name) + " ")], 2) : _c("span", [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 0)], 1)], 1), _c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("页面预览")))])]), _c("a-card", {
    attrs: {
      hoverable: true
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 15
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 0 ? "hit" : ""
  }, [_vm.previewList[0] ? _c("div", {
    key: "one",
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[0])) + " "), _vm.previewList[0].panel.length != 0 && _vm.previewList[0].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[0].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _c("draggable", {
    attrs: {
      group: {
        name: "site",
        pull: false,
        put: true
      },
      animation: "300",
      sort: false
    },
    on: {
      add: e => _vm.addFun(e, 0)
    },
    model: {
      value: _vm.previewCopyList,
      callback: function ($$v) {
        _vm.previewCopyList = $$v;
      },
      expression: "previewCopyList"
    }
  }, [_c("transition-group", {
    staticClass: "group",
    attrs: {
      id: "0"
    }
  }, [_vm.previewList[0] ? _c("div", {
    key: "one",
    staticStyle: {
      height: "100%"
    }
  }, [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(0);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[0],
      itemNum: 0
    }
  })], 1) : _vm._e()])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 9
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 1 ? "hit" : ""
  }, [_vm.previewList[1] ? _c("div", {
    key: "1",
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[1])) + " "), _vm.previewList[1].panel.length != 0 && _vm.previewList[1].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[1].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _c("draggable", {
    attrs: {
      group: {
        name: "site",
        pull: false,
        put: true
      },
      animation: "300",
      sort: false
    },
    on: {
      add: e => _vm.addFun(e, 1)
    },
    model: {
      value: _vm.previewCopyList,
      callback: function ($$v) {
        _vm.previewCopyList = $$v;
      },
      expression: "previewCopyList"
    }
  }, [_c("transition-group", {
    staticClass: "group",
    attrs: {
      id: "1"
    }
  }, [_vm.previewList[1] ? _c("div", {
    key: "1",
    staticStyle: {
      height: "100%"
    }
  }, [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(1);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[1],
      itemNum: 1
    }
  })], 1) : _vm._e()])], 1)], 1)], 1)], 1), _c("a-row", {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 15
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 2 ? "hit" : ""
  }, [_vm.previewList[2] ? _c("div", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[2])) + " "), _vm.previewList[2].panel.length != 0 && _vm.previewList[2].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[2].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _c("draggable", {
    attrs: {
      group: {
        name: "site",
        pull: false,
        put: true
      },
      animation: "300",
      sort: false
    },
    on: {
      add: e => _vm.addFun(e, 2)
    },
    model: {
      value: _vm.previewCopyList,
      callback: function ($$v) {
        _vm.previewCopyList = $$v;
      },
      expression: "previewCopyList"
    }
  }, [_c("transition-group", {
    staticClass: "group",
    attrs: {
      id: "2"
    }
  }, [_vm.previewList[2] ? _c("div", {
    key: "2",
    staticStyle: {
      height: "100%"
    }
  }, [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(2);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[2],
      itemNum: 2
    }
  })], 1) : _vm._e()])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 9
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 3 ? "hit" : ""
  }, [_vm.previewList[3] ? _c("div", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[3])) + " "), _vm.previewList[3].panel.length != 0 && _vm.previewList[3].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[3].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _c("draggable", {
    attrs: {
      group: {
        name: "site",
        pull: false,
        put: true
      },
      animation: "300",
      sort: false
    },
    on: {
      add: e => _vm.addFun(e, 3)
    },
    model: {
      value: _vm.previewCopyList,
      callback: function ($$v) {
        _vm.previewCopyList = $$v;
      },
      expression: "previewCopyList"
    }
  }, [_c("transition-group", {
    staticClass: "group",
    attrs: {
      id: "3"
    }
  }, [_vm.previewList[3] ? _c("div", {
    key: "3",
    staticStyle: {
      height: "100%"
    }
  }, [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(3);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[3],
      itemNum: 3
    }
  })], 1) : _vm._e()])], 1)], 1)], 1)], 1), _c("a-row", {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-card", {
    staticClass: "heightCard",
    class: _vm.current == 4 ? "hit" : ""
  }, [_vm.previewList[4] ? _c("div", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.titleFun(_vm.previewList[4])) + " "), _vm.previewList[4].panel.length != 0 && _vm.previewList[4].panel[0].panelDescription ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.previewList[4].panel[0].panelDescription) + " ")]), _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e(), _vm.queryMethod == "SINGLE" ? _c("div", {
    staticClass: "icon2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.getTimeFrame(_vm.timeFrame))))]), _c("div", {
    staticClass: "iconCont"
  }, [_vm._v(_vm._s("[" + _vm.$t("切换") + "]"))])]) : _vm._e()], 1) : _vm._e(), _c("draggable", {
    attrs: {
      group: {
        name: "site",
        pull: false,
        put: true
      },
      animation: "300",
      sort: false
    },
    on: {
      add: e => _vm.addFun(e, 4)
    },
    model: {
      value: _vm.previewCopyList,
      callback: function ($$v) {
        _vm.previewCopyList = $$v;
      },
      expression: "previewCopyList"
    }
  }, [_c("transition-group", {
    staticClass: "group",
    attrs: {
      id: "4"
    }
  }, [_vm.previewList[4] ? _c("div", {
    key: "4",
    staticStyle: {
      height: "100%"
    }
  }, [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle",
      theme: "filled"
    },
    on: {
      click: function ($event) {
        return _vm.handleDelPanel(4);
      }
    }
  }), _c("echarts-item", {
    attrs: {
      itemObj: _vm.previewList[4],
      itemNum: 4
    }
  })], 1) : _vm._e()])], 1)], 1)], 1)], 1)], 1), _vm.isPanelShow ? _c("custom-model", {
    ref: "customRef",
    attrs: {
      customerId: _vm.customerId
    },
    on: {
      cancel: function ($event) {
        ;
        _vm.isPanelShow = false, _vm.current = -1;
      },
      ok: _vm.addTemplateFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };